import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[appDynamicElementsContainer]' })
export class DynamicElementsContainerDirective {
	constructor(public viewContainerRef: ViewContainerRef) { }
}
